import api from '@src/api/clients';

const BASE = 'meetings/';

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== '',
    ),
  );

// GET /api/meetings/clients/<slug>/policy/
export const fetchMeetingPolicy = (clientSlug) =>
  api.request({
    url: `${BASE}clients/${clientSlug}/policy/`,
    method: 'GET',
  });

// GET /api/meetings/clients/<slug>/availability/?from=&to=
export const fetchAvailability = (clientSlug, params = {}) =>
  api.request({
    url: `${BASE}clients/${clientSlug}/availability/`,
    method: 'GET',
    payload: cleanParams(params),
  });

// GET /api/meetings/clients/<slug>/bookings/
export const fetchBookings = (clientSlug) =>
  api.request({
    url: `${BASE}clients/${clientSlug}/bookings/`,
    method: 'GET',
  });

// POST /api/meetings/clients/<slug>/bookings/
export const createBooking = (clientSlug, payload) =>
  api.request({
    url: `${BASE}clients/${clientSlug}/bookings/`,
    method: 'POST',
    payload,
  });

// POST /api/meetings/bookings/<id>/cancel/
export const cancelBooking = (bookingId, payload = {}) =>
  api.request({
    url: `${BASE}bookings/${bookingId}/cancel/`,
    method: 'POST',
    payload,
  });

// POST /api/meetings/bookings/<id>/reschedule/  — quota-neutral in-place move
export const rescheduleBooking = (bookingId, payload) =>
  api.request({
    url: `${BASE}bookings/${bookingId}/reschedule/`,
    method: 'POST',
    payload,
  });

// GET /api/meetings/clients/<slug>/meeting-requests/
export const fetchMeetingRequests = (clientSlug) =>
  api.request({
    url: `${BASE}clients/${clientSlug}/meeting-requests/`,
    method: 'GET',
  });

// POST /api/meetings/clients/<slug>/meeting-requests/
export const createMeetingRequest = (clientSlug, payload) =>
  api.request({
    url: `${BASE}clients/${clientSlug}/meeting-requests/`,
    method: 'POST',
    payload,
  });

// GET /api/meetings/clients/<slug>/meeting-history/?limit=10
export const fetchMeetingHistory = (clientSlug, params = {}) =>
  api.request({
    url: `${BASE}clients/${clientSlug}/meeting-history/`,
    method: 'GET',
    payload: cleanParams(params),
  });

// ── Staff: access grants + request approval (IsAdminUser) ──────────────────

// GET /api/meetings/meeting-requests/?status=open|resolved
export const fetchAllMeetingRequests = (params = {}) =>
  api.request({
    url: `${BASE}meeting-requests/`,
    method: 'GET',
    payload: cleanParams(params),
  });

// GET /api/meetings/staff-bookings/?days=14  — upcoming booked meetings
export const fetchStaffUpcomingBookings = (params = {}) =>
  api.request({
    url: `${BASE}staff-bookings/`,
    method: 'GET',
    payload: cleanParams(params),
  });

// GET /api/meetings/clients/<slug>/staff-context/
export const fetchMeetingStaffContext = (clientSlug) =>
  api.request({
    url: `${BASE}clients/${clientSlug}/staff-context/`,
    method: 'GET',
  });

// POST /api/meetings/clients/<slug>/grants/  — one-off staff bypass
export const issueMeetingGrant = (clientSlug, payload = {}) =>
  api.request({
    url: `${BASE}clients/${clientSlug}/grants/`,
    method: 'POST',
    payload,
  });

// POST /api/meetings/meeting-requests/<id>/approve/
export const approveMeetingRequest = (requestId, payload = {}) =>
  api.request({
    url: `${BASE}meeting-requests/${requestId}/approve/`,
    method: 'POST',
    payload,
  });

// POST /api/meetings/meeting-requests/<id>/decline/
export const declineMeetingRequest = (requestId, payload = {}) =>
  api.request({
    url: `${BASE}meeting-requests/${requestId}/decline/`,
    method: 'POST',
    payload,
  });

// POST /api/meetings/grants/<id>/revoke/
export const revokeMeetingGrant = (grantId) =>
  api.request({
    url: `${BASE}grants/${grantId}/revoke/`,
    method: 'POST',
  });
